module.exports = __webpack_public_path__ + "3b359c4516b09bc6fbcc60900a3ad067.png";